module.exports = __webpack_public_path__ + "img/张海东.32c4cd56.jpg";